module.exports = __webpack_public_path__ + "img/bg01.0658b280.png";